module.exports = __webpack_public_path__ + "statics/img/3.dd03264.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/3.png
// module id = 3FWb
// module chunks = 1